import { Route } from "@angular/router";
import { ChildPermissions } from "@malirang/common";
import { DetailChildLayout } from "../pages/child/detail-child/layout/detail-child.layout";

export const childRoutes: Route[] = [
    {
        path: "child",
        children: [
            {
                path: "",
                title: "아동 목록",
                loadComponent: () => import("../pages/child/child.page"),
            },
            {
                path: "find",
                title: "아동 찾기",
                data: {
                    requiredRoles: [ChildPermissions.CHILD_EDIT],
                },
                loadComponent: () =>
                    import("../pages/child/find-child/find-child.page"),
            },
            {
                path: "form",
                title: "아동 등록",
                data: {
                    requiredRoles: [ChildPermissions.CHILD_EDIT],
                },
                loadComponent: () =>
                    import(
                        "../pages/child/find-child/create-child/create-child.page"
                    ),
            },
            {
                path: ":id/detail/:childId",
                component: DetailChildLayout,
                data: {
                    requiredRoles: [ChildPermissions.CHILD_READ],
                },
                children: [
                    {
                        path: "",
                        title: "아동 상세",
                        loadComponent: () =>
                            import(
                                "../pages/child/detail-child/detail-child.page"
                            ),
                    },
                    {
                        path: "guardian/:guardianId",
                        title: "보호자 상세",
                        loadComponent: () =>
                            import(
                                "../pages/child/detail-child/guardian/detail-guardian/detail-guardian.page"
                            ),
                    },
                    {
                        path: "ticket/:ticketId",
                        title: "서비스 상세",
                        loadComponent: () =>
                            import(
                                "../pages/child/detail-child/ticket/detail-ticket/detail-ticket.page"
                            ),
                    },
                ],
            },
        ],
    },
];
